import type { ConsolaInstance, ConsolaOptions } from 'consola'
import type { LogHandler, LogLevel } from './log'
import { Log } from './log'

const levelMap = {
  error: 0,
  warn: 1,
  info: 3,
  debug: 4,
}

function toConsolaLogLevel(level: LogLevel) {
  return levelMap[level]
}

export default function createLog(createConsola: (options?: Partial<ConsolaOptions>) => ConsolaInstance, space: string | undefined = 'default-storefront', level: LogLevel) {
  const logger = createConsola({
    level: toConsolaLogLevel(level),
  })
  const handler: LogHandler = (entry) => {
    const data = entry.data
    const log = logger[entry.level] || logger.info
    const message = `[${entry.space}] ${entry.message}`
    const args = data ? [message, data] : [message]
    // @ts-expect-error - logger methods expect a string message and optional data
    log.apply(log, args)
  }
  return new Log({
    space,
    handler,
  })
}
